import { createFileRoute } from '@tanstack/react-router'
import { ReceivableDetailPage } from '@/features/receivables/receivable-detail-page'

export const Route = createFileRoute('/_authenticated/receivables/$invoiceId')({
  staticData: { title: 'AR Invoice' },
  component: ReceivableRoute,
})

function ReceivableRoute() {
  const { invoiceId } = Route.useParams()
  return <ReceivableDetailPage invoiceId={invoiceId} />
}
